import QuestionHeader from "../question-header";

export const TextFieldQuestion = ({ question, value, onChange, error, helperText }) => {
  console.log(question, "8976");
  return (
    <div className="space-y-6">
      <QuestionHeader label={question.label} description={question.description} required={question.required} />

      <div className="relative">
        <input
          type={question.type === 4 ? "number" : "text"}
          value={value || ""}
          onChange={(e) => onChange(e.target.value)}
          placeholder={question.placeholder || "Type your answer here…"}
          className={`w-full bg-transparent text-lg text-text-primary placeholder-text-muted px-1 py-3 border-b-2 transition-colors duration-200 outline-none ${
            error ? "border-error focus:border-error" : "border-primary/60 focus:border-primary"
          }`}
          onKeyDown={(e) => {
            if (e.key === "e" || e.key === "E") {
              e.preventDefault();
            }
          }}
        />

        <span
          className={`absolute left-0 bottom-0 h-[2px] w-full scale-x-0 origin-left transition-transform duration-200 ${
            error ? "bg-error" : "bg-primary"
          }`}
        />
      </div>

      {helperText && <p className="text-sm text-error text-left">{helperText}</p>}
    </div>
  );
};
